<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <div
      :class="[
        theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4'
      ]"
    >
      <div class="flex items-center justify-between">
        <div>
          <h1
            :class="[
              theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
              'text-2xl font-bold'
            ]"
          >
            Database
          </h1>
          <p
            :class="[
              theme.isDark.value ? 'text-gray-400' : 'text-gray-600',
              'mt-1 text-sm'
            ]"
          >
            Common database actions and information for multiple databases
          </p>
        </div>
      </div>
    </div>

    <div class="p-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
        <router-link
          to="/database/firestore"
          :class="[
            theme.isDark.value ? 'bg-gray-800 border-gray-700 hover:bg-gray-700' : 'bg-white border-gray-200 hover:bg-gray-50',
            'border rounded-lg p-6 transition-colors cursor-pointer block'
          ]"
        >
          <h2
            :class="[
              theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
              'text-lg font-semibold mb-2'
            ]"
          >
            Firestore
          </h2>
          <p
            :class="[
              theme.isDark.value ? 'text-gray-400' : 'text-gray-600',
              'text-sm'
            ]"
          >
            View index definitions and index usage information for Firestore collections.
          </p>
          <span
            :class="[
              theme.isDark.value ? 'text-blue-400' : 'text-blue-600',
              'text-sm font-medium mt-2 inline-block'
            ]"
          >
            Open Firestore →
          </span>
        </router-link>

        <router-link
          to="/database/mongo"
          :class="[
            theme.isDark.value ? 'bg-gray-800 border-gray-700 hover:bg-gray-700' : 'bg-white border-gray-200 hover:bg-gray-50',
            'border rounded-lg p-6 transition-colors cursor-pointer block'
          ]"
        >
          <h2
            :class="[
              theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
              'text-lg font-semibold mb-2'
            ]"
          >
            Mongo
          </h2>
          <p
            :class="[
              theme.isDark.value ? 'text-gray-400' : 'text-gray-600',
              'text-sm'
            ]"
          >
            View cluster and collections, indexes, and performance metrics for MongoDB.
          </p>
          <span
            :class="[
              theme.isDark.value ? 'text-blue-400' : 'text-blue-600',
              'text-sm font-medium mt-2 inline-block'
            ]"
          >
            Open Mongo →
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import { useTheme } from '../../utils/useTheme'

export default defineComponent({
  name: 'DatabaseLanding',
  setup() {
    const theme = inject('theme', useTheme())
    return { theme }
  }
})
</script>
